/**
 * Tracker #25 (global): block saving any money document/bill whose grand total
 * is zero or empty. Used as a form-level `validate` on SimpleForm.
 */
export const requireNonZeroTotal = (values: any) => {
    const total = parseFloat(String(values?.total_amount ?? '0')) || 0;
    if (total <= 0) {
        return { total_amount: 'Add at least one line item — total cannot be ₹0' };
    }
    return {};
};
